export const iconFontAwesomeAnimalsHorseHead = (
	<i className="fa-solid fa-horse-head"></i>
);
